export default __webpack_public_path__ + "static/media/harbour-premium-license.ab2d3da6.jpg";